import * as React from 'react'
import { PrismicProvider } from '@prismicio/react'
import { PrismicPreviewProvider } from 'gatsby-plugin-prismic-previews'

// Utils
import { repositoryConfigs } from './src/utils/prismicPreviews'
import { linkResolver } from './src/utils/linkResolver'
import { ExternalLink } from './src/utils/externalLink'

import '@fontsource/montserrat/300.css'
import '@fontsource/montserrat/500.css'
import '@fontsource/montserrat/600.css'
import '@fontsource/montserrat/700.css'

import '@fontsource/jost/400.css'
import '@fontsource/jost/700.css'
import '@fontsource/jost/900.css'

import './src/styles/default.css'

export const wrapRootElement = ({ element }) => (
  <PrismicProvider linkResolver={linkResolver} externalLinkComponent={ExternalLink}>
    <PrismicPreviewProvider repositoryConfigs={repositoryConfigs}>{element}</PrismicPreviewProvider>
  </PrismicProvider>
)
